import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PersistStorage } from 'zustand/middleware'

export interface UtilityStore {
  actionedMedicationRequestIds: Array<string>
  setActionedMedicationRequestIds: (ids: Array<string>) => void
  actionedInvestigationIds: Array<string>
  setActionedInvestigationIds: (ids: Array<string>) => void
}

const utilityStorage: PersistStorage<Omit<UtilityStore, 'currentMedRequest'>> = {
  getItem: name => {
    const str = localStorage.getItem(name)
    if (!str) return null
    return JSON.parse(str)
  },
  setItem: (name, value) => {
    localStorage.setItem(name, JSON.stringify(value))
  },
  removeItem: name => localStorage.removeItem(name)
}

const useUtilityStore = create<UtilityStore>()(
  persist(
    set => ({
      actionedMedicationRequestIds: [],
      setActionedMedicationRequestIds: (ids: Array<string>) => set({ actionedMedicationRequestIds: ids }),
      actionedInvestigationIds: [],
      setActionedInvestigationIds: (ids: Array<string>) => set({ actionedInvestigationIds: ids })
    }),
    {
      name: 'utility-store',
      storage: utilityStorage
    }
  )
)

export const resetUtilityStore = () => useUtilityStore.setState(useUtilityStore.getInitialState())

export { useUtilityStore }
